import { OnInit, Output, EventEmitter, Input, AfterViewInit } from '@angular/core';

import { AbstractValidatorEditor, ControlValidatorModel } from '../../../types/validator.types';
import { AbstractControl, ControlViewModel } from '../../../types/control.types';
import { cloneDeep } from 'lodash';

export abstract class ValidatorEditorBase<T> implements OnInit, AbstractValidatorEditor<T>, AfterViewInit {
  @Output() modelChange: EventEmitter<ControlValidatorModel<T>>;
  @Output() valueChange: EventEmitter<ControlValidatorModel<T>>;

  @Input()
  get control(): AbstractControl<any> {
    return this._control;
  }
  set control(value: AbstractControl<any>) {
    this._control = value;
  }

  @Input()
  get caption(): string {
    return this._caption;
  }
  set caption(val: string) {
    this._caption = val;
  }

  @Input()
  get validatorName(): string {
    return this._validatorName;
  }
  set validatorName(value: string) {
    this._validatorName = value;
  }

  @Input()
  get model() {
    return this._model;
  }

  set model(model: ControlValidatorModel<T>) {
    this._model = cloneDeep(model);
    if (!this._model) {
      this._model = { required: undefined, data: this.defaultModelData() };
    }
    if (!this._model.data) {
      this._model.data = this.defaultModelData();
    }
    this.afterModelInit();
  }

  @Input()
  settings: any = {};

  /**
   * æ¯å¦éä¸­
   *
   * @memberof ValidatorEditorBase
   */
  get required(): boolean {
    return this.model.required;
  }
  set required(val: boolean) {
    this.model.required = val;
    this.modelChange.emit(this.model);
  }

  /**
   * data
   *
   * @memberof ValidatorEditorBase
   */
  get data(): T {
    return this.model.data;
  }
  set data(data: T) {
    this.model.data = data;
  }

  initComplete: boolean;

  protected _control: AbstractControl<ControlViewModel>;
  protected _validatorName: string;
  protected _model: ControlValidatorModel<T>;
  protected _caption: string;

  constructor() {
    this.modelChange = new EventEmitter<ControlValidatorModel<T>>();
    this.valueChange = new EventEmitter<ControlValidatorModel<T>>();
    this.initComplete = false;
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.initComplete = true;
  }

  /**
   * emitå¼æ¹åäºä»¶
   *
   * @memberof ValidatorEditorBase
   */
  emitModelChange() {
    this.modelChange.emit(this._model);
  }

  /**
   * emitå¼æ¹åäºä»¶
   *
   * @memberof ValidatorEditorBase
   */
  emitValueChange() {
    this.valueChange.emit(this._model);
  }

  /**
   * é»è®¤éªè¯å¨dataå¼
   *
   * @abstract
   * @returns {T}
   * @memberof ValidatorEditorBase
   */
  abstract defaultModelData(): T;

  /**
   * åå§åéªè¯å¨Modelå
   *
   * @memberof ValidatorEditorBase
   */
  afterModelInit(): void {}
}
